import { useState } from "react"
import { useQuery } from "@tanstack/react-query"

/**
 * Trace eines Vorgangs auf Klick — jeder Modellaufruf und jeder Schritt an
 * einem Faden (#64 Teil A). Fuer Anrufe (`call`) und Mails (`email`).
 */
type Schritt = { schritt: string; modell: string | null; dauer_ms: number | null; kosten_cents: number; created_at: string | null; ausgabe_kurz: string | null; details: Record<string, unknown> | null }

const wann = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : ""

export function VorgangTrace({ art, id }: { art: "call" | "email" | "sipgate_call"; id: string | number }) {
  const [offen, setOffen] = useState(false)
  const q = useQuery<{ schritte: Schritt[]; kosten_cents: number }>({
    queryKey: ["vorgang-trace", art, String(id)],
    enabled: offen,
    queryFn: async () => {
      const r = await fetch(`/api/v1/vorgang-trace/${art}/${encodeURIComponent(String(id))}`, { credentials: "include" })
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      return r.json()
    },
  })
  return (
    <div className="text-[12px]" data-testid="vorgang-trace">
      <button type="button" className="pp-btn pp-btn-sm" onClick={() => setOffen((o) => !o)}>
        {offen ? "Trace ausblenden" : "Trace des Vorgangs"}
      </button>
      {offen && q.data && (
        <ul style={{ margin: "4px 0 0 14px", padding: 0 }}>
          {q.data.schritte.length === 0 && <li className="text-muted-foreground">Noch kein Schritt aufgezeichnet.</li>}
          {q.data.schritte.map((s, i) => (
            <li key={i}>
              {wann(s.created_at)} · <strong>{s.schritt}</strong>
              {s.modell ? ` · ${s.modell}` : ""}{s.dauer_ms != null ? ` · ${(s.dauer_ms / 1000).toFixed(1)} s` : ""}
              {s.kosten_cents ? ` · ${s.kosten_cents.toFixed(2)} ¢` : ""}
              {s.details && !s.modell ? ` · ${Object.entries(s.details).filter(([, v]) => v != null && typeof v !== "object").map(([k, v]) => `${k}=${String(v)}`).join(", ")}` : ""}
            </li>
          ))}
          {q.data.schritte.length > 0 && <li className="text-muted-foreground">Summe {q.data.kosten_cents.toFixed(2)} ¢</li>}
        </ul>
      )}
    </div>
  )
}
